import React from 'react';
import { Modal } from '@fragments';
import StoryForm from '../../components/StoryForm';

export default function StoryDialog({ studio: s }) {
  return <Modal open closeLabel={s.t('close')} onClose={() => s.setModal(null)} title={s.t('storyTitle')} subtitle={s.t('storyHint')} size="md" className="studio-dialog"><StoryForm studio={s} /></Modal>;
}
